<template>
  <div class="gap-2 flex lg:items-center flex-col lg:flex-row mb-2 lg:mb-0">
    <slot />
  </div>
</template>
